import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@material-ui/core';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@material-ui/lab';
import { titleize } from '../../util/stringUtil';
import { dateTimeToS } from '../../util/dateUtil';
import formStyles from './ScholarshipApp.styles';

const ScholarshipStatusHistory = ({ history }) => {
  const classes = formStyles?.() || {};
  const items = Array.isArray(history) ? history : [];

  if (!items.length) return null;

  const sorted = [...items].sort((a, b) => {
    const at = a?.timeStamp ? new Date(a.timeStamp).getTime() : 0;
    const bt = b?.timeStamp ? new Date(b.timeStamp).getTime() : 0;
    return at - bt;
  });

  return (
    <Grid item xs={12} style={{ marginTop: 15 }}>
      <Box sx={{ width: '100%' }}>
        <Grid item xs={12} className={classes.gradingSectionTitle || ''} style={{ marginTop: 30 }}>
          Status History
        </Grid>
        <Timeline style={{ paddingLeft: 25, marginTop: -40 }}>
          {sorted.map((h, idx) => {
            const status = h?.status ? titleize(h.status) : '';
            const who = h?.status_by || h?.statusBy || '';
            const when = h?.timeStamp ? dateTimeToS(h.timeStamp) : '';
            return (
              <TimelineItem key={`${h?.status || 'status'}-${h?.timeStamp || idx}`}>
                <TimelineSeparator>
                  <TimelineDot color="grey" />
                  {idx < sorted.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <div style={{ fontWeight: 600, marginTop: -5 }}>{status}</div>
                  <div style={{ fontSize: '0.9rem' }}>{when}</div>
                  {who && <div style={{ fontSize: '0.9rem' }}>By: {who.toString()}</div>}
                </TimelineContent>
              </TimelineItem>
            );
          })}
        </Timeline>
      </Box>
    </Grid>
  );
};

ScholarshipStatusHistory.propTypes = {
  history: PropTypes.array,
};

export default ScholarshipStatusHistory;
